import React from 'react'
import { Card, Row, Col, Button, Typography} from 'antd';
import { StarFilled } from '@ant-design/icons';
import BoltSvg from '../../assets/KarmaIcons/bolt';
import StarIcon from '../../assets/KarmaIcons/StarIcon.png';


const { Title, Text } = Typography;

const performersData = [
  {
    id: 1,
    name: 'Alex Johnson',
    title: 'Frontend Developer',
    points: 600,
  },
  {
    id: 2,
    name: 'Priya Mehta',
    title: 'UX Designer',
    points: 270,
  },
  {
    id: 3,
    name: 'John Doe',
    title: 'Project Manager',
    points: 250,
  },
];

const Karmaanalytics = () => {
  return (
    <div className="rewards-container karma-wrapper">

      <Card className="rewards-header welcome-card">
        <div className="rewards-title-container">
          <h2 className="rewards-title"> <imag src={ StarIcon } alt="star-icon" />  Total Karma: <span className='total-karma'>120 <BoltSvg /></span> </h2>
        </div>
      </Card>
      <Card className="stats-card">
        {/* Karma Stats Pills */ }
        <Row gutter={ 24 } justify="space-between" className="rewards-row">
          <Col xs={ 24 } sm={ 12 } lg={ 8 } className='reward-wrapper'>
            <Card className="karma-stat-card">
              <div className="reward-title">
                <h2 >     Karma Received </h2>

              </div>
              <div className="points-container">
                <span className="points-value"> <p> 50 </p></span>
                <span role="img" aria-label="lightning" className="lightning-icon">
                  <BoltSvg />
                </span>
              </div>
            </Card>
          </Col>
          <Col xs={ 24 } sm={ 12 } lg={ 8 } className='reward-wrapper'>
            <Card className="karma-stat-card">
              <div className="reward-title">
                <h2 >     Karma Received</h2>

              </div>
              <div className="points-container">
                <span className="points-value"> <p>  20 </p></span>
                <span role="img" aria-label="lightning" className="lightning-icon">
                  <BoltSvg />
                </span>
              </div>
            </Card>
          </Col>
          <Col xs={ 24 } sm={ 12 } lg={ 8 } className='reward-wrapper'>
            <Card className="karma-stat-card">
              <div className="reward-title">
                <h2 >     Karma Received</h2>

              </div>
              <div className="points-container">
                <span className="points-value"> <p>  10 </p></span>
                <span role="img" aria-label="lightning" className="lightning-icon">
                  <BoltSvg />
                </span>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Send Karma Button */ }
        <div className="karma-button-container">
          <Button type="primary" icon={ <StarFilled /> } className="send-karma-btn">
            <strong>           Send Karma  </strong>

            <div id="container-stars">
              <div id="stars"></div>
            </div>

            <div id="glow">
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
          </Button>
        </div>
      </Card>

    </div>
  )
}

export default Karmaanalytics